import React from 'react';
import { ManualPOList } from './ManualPOList';
import { RACAccordion, makeStyles, Typography } from '@rentacenter/racstrap';
import { SectionProps } from './ReceivingPO';
import { POSection } from '../../constants/constants';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  receivingPOManualRoot: {
    margin: `${theme.typography.pxToRem(16)} 0`,
  },
  h4: {
    marginTop: '.5rem',
  },
  accordionSummaryContent: {
    margin: '0 !important',
  },
}));

export const ManualPOSection = ({ selected, onChange }: SectionProps) => {
  const classes = useStyles();
  const expanded = selected === POSection.ManualPO;
  const { t } = useTranslation();

  return (
    <>
      <RACAccordion
        details={<ManualPOList expanded={expanded} />}
        summary={
          <Typography variant="h4" className={classes.h4}>
            {t('PO Manual Receiving')}
          </Typography>
        }
        accordionProps={{
          classes: {
            root: classes.receivingPOManualRoot,
          },
          expanded: expanded,
          onChange: onChange(expanded ? '' : POSection.ManualPO),
        }}
        summaryProps={{
          classes: {
            content: classes.accordionSummaryContent,
          },
        }}
      />
    </>
  );
};
